export const ADMIN_GLOBAL_SETTING_KEYS = [
	"VITE_ENABLE_REPORTS",
	"VITE_ENABLE_WHATS_NEW",
	"VITE_ENABLE_REVIEWS_PAGE",
	"VITE_ENABLE_SPARKY_REPORT_NOTIFICATIONS",
	"VITE_ENABLE_SCRIBE_IFRAME_REPORTS",
	"VITE_ENABLE_PDF_REPORT_HEADER",
	"VITE_ENABLE_EMBEDDED_SPARK_EDITOR",
	"VITE_ENABLE_SCRIBE_DEFAULT_INSTALL",
	"VITE_DISABLE_SCRIBE_POLLING",
	"VITE_SPARKY_INCLUDE_DOCUMENTS",
	"VITE_ENABLE_LUCKY_REPORT_QUOTA_CHECK",
	"VITE_SHOW_MARKETING_BANNER",
	"VITE_ENABLE_PURCHASE_MODULE",
	"VITE_ENABLE_ATTRIBUTES",
	"VITE_MAINTENANCE_MODE_ACTIVE",
	"VITE_UPLOADS_OFFER_CHUNKED_OBJECT",
	"VITE_SCRIBE_INTEGRATIONS"
] as const;

export async function loadAdminGlobalSettings(environment: Record<string, string>, fetcher: typeof fetch = fetch): Promise<void> {
	// AbortSignal.timeout is absent on the supported Safari/iOS 15 browser floor.
	const controller = new AbortController();
	const timeout = setTimeout(() => controller.abort(), 10000);
	try {
		const response = await fetcher(`${environment.VITE_API_ROOT.replace(/\/$/, "")}/public/global-settings/admin`, {
			cache: "no-store",
			signal: controller.signal
		});
		if (!response.ok) throw new Error("Unable to load global settings");
		const settings: unknown = await response.json();
		if (
			!settings ||
			typeof settings !== "object" ||
			(settings as Record<string, unknown>).__policyReady !== true ||
			ADMIN_GLOBAL_SETTING_KEYS.some((key) => !["true", "false"].includes((settings as Record<string, string>)[key]))
		)
			throw new Error("Invalid global settings");
		for (const key of ADMIN_GLOBAL_SETTING_KEYS) environment[key] = (settings as Record<string, string>)[key];
		delete environment.SCRIBE_INTEGRATIONS;
	} catch (error) {
		console.warn("Unable to load global settings; keeping the startup environment", error);
	} finally {
		clearTimeout(timeout);
	}
}
